import { WSModal, WSModalCustomProps } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { useRequirementHistoryResources } from "../hooks/useRequirementHistoryResources";
type Props = {
  requirement: IRequirementResponse;
} & WSModalCustomProps<void>;

export const ModalRequirementHistory: React.FC<Props> = ({
  requirement,
  ...modalProps
}) => {
  const scope = useRequirementHistoryResources(requirement);

  return (
    <WSModal title="Requirement history" {...modalProps}>
      <ResourceHistory resources={scope} />
    </WSModal>
  );
};
